export default __webpack_public_path__ + "602d8d4416c684c32cccc0f254a58795.png";